document.addEventListener('click', function (e) {
	const openAccountLink = e.target.closest('a');
	if (
		openAccountLink &&
		openAccountLink.textContent.trim().includes('Open Account')
	) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'ctaStartCDAO'
		});
	}
});